var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisTextLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25H9.16667C6.14182 19.25 4.6294 19.25 3.6897 18.3103C2.75 17.3706 2.75 15.8582 2.75 12.8333V2.75",
    stroke: "#423F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 3.66667H7.33341",
    stroke: "#423F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 6.41667H10.0834",
    stroke: "#423F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 18.3333C5.56494 16.5486 6.89581 11.934 9.44736 11.934C11.2108 11.934 11.6675 14.1824 13.3957 14.1824C16.369 14.1824 15.938 9.16667 19.2499 9.16667",
    stroke: "#423F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisTextLink);
export default __webpack_public_path__ + "static/media/analysis-text-link.28de203705d548681c626ebcaf8c25d6.svg";
export { ForwardRef as ReactComponent };